import { GatewayStatus } from 'constants/gatewayStatuses';

import Title from '@mui/icons-material/Title';
import { green, red } from '@mui/material/colors';
import { ReactComponent as PilotIcon } from 'images/pilotFilled.svg';
import { Chip } from 'shared/mui/Chips';
import { ColorIcon } from 'shared/mui/Chips/ColorChip/ColorChip';
import {
  FunctionFieldProps,
  FunctionField,
} from 'shared/react-admin/Fields/FunctionField/FunctionField';
import { Gateway } from 'types/embedded/gateway';

import { FallbackIconStyled } from './GatewayStatusChipField.styled';

export type GatewayStatusIconFieldProps = Omit<FunctionFieldProps, 'render'>;

const STATUS_ICONS: Record<GatewayStatus, JSX.Element> = {
  [GatewayStatus.Active]: <ColorIcon color={green[500]} size="l" />,
  [GatewayStatus.Disabled]: <ColorIcon color={red[500]} size="l" />,
  [GatewayStatus.Test]: <Title color="warning" />,
  [GatewayStatus.Pilot]: <PilotIcon />,
};

export const GatewayStatusChipField = (props: GatewayStatusIconFieldProps): JSX.Element => (
  <FunctionField
    {...props}
    render={(record: Gateway) => {
      const status = record?.status?.value as GatewayStatus;

      if (!status) {
        return <FallbackIconStyled />;
      }

      const icon = STATUS_ICONS[status] ?? <FallbackIconStyled />;

      return <Chip icon={icon} label={record?.status?.description} />;
    }}
  />
);
